<template lang="pug">
.list-container
  .crumbs-container
    slot(name="crumbs")
      el-breadcrumb(separator-class="el-icon-arrow-right")
        el-breadcrumb-item(v-for="(item, index) in path" :key="index" :to="item.to") {{ item.label }}
  .tab-operation-container
    .tab-wrapper
      slot(name="tab")
        //ListTab(:config.sync="tabConfig" @change="handleTabChange")
        .tab-container
          .tab-item(v-for="(item, itemIndex) in tabConfig.list" :key="itemIndex"
            :class="{'active': itemIndex === tabConfig.currentIndex}"
            @click="handleItemClick(item, itemIndex)") {{ item.label }}
    .operation-wrapper
      slot(name="operation")
  .classification-container
    slot(name="classification")
      ListClassification(v-if="filterVisible"
        :filter="filterConfig"
        @change="handleFilterChange")
  .search-container
    slot(name="search")
      .list-search-container(v-if="searchVisible")
        .search-input
          input(placeholder="输入关键词搜索" v-model="keywords")
          .icon(@click="handleSearch")
  .list-content-container(:class="[layout]" v-loading="listLoading")
    el-empty(description="暂无数据" v-if="listNoData")
    slot(name="list")
  .pagination-container
    slot(name="pager")
</template>

<script>
export default {
  name: "ListContainer",
  props: {
    layout: {
      type: String,
      default: 'list'
    },
    path: {
      type: Array,
      default() {
        return []
      }
    },
    // 转发封装的TAB
    tabConfig: {
      type: Object,
      default() {
        return {
          currentIndex: 0,
          list: []
        }
      }
    },
    filterConfig: Array,
    filterVisible: Boolean,
    searchKeyword: String,
    searchVisible: Boolean,
    listLoading: Boolean,
    listNoData: Boolean,
  },
  data() {
    return {
      keywords: '',
    }
  },
  watch: {
    keywords(v) {
      this.$emit('update:searchKeyword', v);
    }
  },
  methods: {
    // 转发封装的TAB变化
    handleItemClick(item, index) {
      this.$emit('update:tabConfig', {
        ...this.tabConfig,
        currentIndex: index,
      });
      this.$emit('tabChange', {
        item,
        index,
      });
    },
    handleFilterChange(params) {
      this.$emit('filterChange', params);
    },
    handleSearch() {
      this.$emit('search');
    }
  }
}
</script>

<style lang="scss" scoped>
.list-container{
  background-color: white;
  padding: 16px 24px;
  .crumbs-container{
    padding-bottom: 16px;
  }
  .tab-operation-container{
    display: flex;
    padding-bottom: 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    .tab-wrapper{
      flex: 1;
      .tab-container{
        display: flex;
        .tab-item{
          height: 32px;
          padding: 0 22px;
          border: 1px solid rgba(0, 0, 0, 0.1);
          box-sizing: border-box;
          color: rgba(32, 41, 72, 0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-size: 12px;
          & + .tab-item{
            margin-left: 8px;
          }
          &.active{
            background: #007739;
            border: 1px solid #007739;
            color: #FFFFFF;
          }
        }
      }
    }
  }
  .list-content-container{
    display: flex;
    min-height: 200px;
    &.list{
      flex-direction: column;
    }
    &.grid{
      flex-direction: row;
      flex-wrap: wrap;
    }
  }
  .pagination-container{
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }
}

.list-search-container{
  padding: 12px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  .search-input{
    border: 1px solid rgba(0, 0, 0, 0.1);
    @include size(206px, 32px);
    display: flex;
    input{
      flex: 1;
      display: block;
      border: none;
      outline: none;
      @include size(174px, 100%);
      padding: 0 0 0 12px;
      font-size: 12px;
      box-sizing: border-box;
    }
    .icon{
      @include square(32px);
      background: url("~@/assets/list/icon-search.svg") no-repeat center;
      cursor: pointer;
    }
  }
}
</style>
